export default __webpack_public_path__ + "static/media/season_4_mapfull.56212983.png";